import { render, staticRenderFns } from "./LoadingMask.vue?vue&type=template&id=35ba3f76&scoped=true&"
import script from "./LoadingMask.vue?vue&type=script&lang=js&"
export * from "./LoadingMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba3f76",
  null
  
)

export default component.exports